export default {
  install(app, router) {
    // Отслеживание переходов между страницами
    router.afterEach((to) => {
      // Дожидаемся обновления DOM
      setTimeout(() => {
        if (window.ym) {
          window.ym(103617531, 'hit', to.fullPath);
        }
      }, 0);
    });
  }
};